import { createFileRoute } from '@tanstack/react-router'

import { UserGroupDetailsForm } from '@/user-groups/components/UserGroupDetails/UserGroupDetailsForm'

const Component = () => {
  const { groupId } = Route.useParams()
  const navigate = Route.useNavigate()

  const handleClose = () => {
    navigate({
      to: '/company/groups',
      search: (previous) => previous,
    })
  }

  return <UserGroupDetailsForm onClose={handleClose} groupId={groupId} />
}

export const Route = createFileRoute(
  '/company/_management/groups/$groupId/details',
)({
  component: Component,
})
